import { Network } from '@ionic-native/network';
import { Injectable } from '@angular/core';
import { Platform } from 'ionic-angular/platform/platform';
import { Observable } from 'rxjs/Observable';

import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/take';

@Injectable()
export class NetworkMonitorService {
  private connectedStatus: boolean = true;
  private onDevice: boolean;

  constructor(
    private network: Network,
    private platform: Platform,
  ) {
    this.network.onConnect().subscribe(() => {
      this.connectedStatus = true;
    });

    this.network.onDisconnect().subscribe(() => {
      this.connectedStatus = false;
    });

    this.onDevice = this.platform.is('cordova');
    this.connectedStatus = this.onDevice
      ? (this.network.type !== 'none')
      : true;
  }

  public isConnected(): boolean {
    return this.connectedStatus;
  }

  public whenConnected(): Observable<boolean> {
    if (this.isConnected()) {
      return Observable.of(true);
    }

    return this.network.onConnect().take(1);
  }
}
